// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Text_wrapper__I4Em_","container":"Text_container__66BHb","btnContainer":"Text_btnContainer__YxiZn"};